import {Component, OnInit} from '@angular/core';
import {
  fadeInLeftOnEnterAnimation,
  fadeInOnEnterAnimation,
  fadeOutOnLeaveAnimation,
  fadeOutRightOnLeaveAnimation
} from 'angular-animations';
import {DomSanitizer} from '@angular/platform-browser';
import {UserService} from '../../../services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserJourneysModel} from '../../journey/models/journey-page.model';
import {DelegateSummaryModel} from '../models/delegate.model';
import {TeamService} from '../service/team.service';

@Component({
  selector: 'app-team-calls-history-iframe-page',
  templateUrl: './team-calls-history-iframe.page.html',
  styleUrls: ['./team-calls-history-iframe.page.scss'],
  animations: [
    fadeInOnEnterAnimation({anchor: 'enter', duration: 500}),
    fadeOutOnLeaveAnimation({anchor: 'leave', duration: 500}),
    fadeOutRightOnLeaveAnimation({anchor: 'leaveList', duration: 300}),
    fadeInLeftOnEnterAnimation({anchor: 'enterList', duration: 300}),
  ]
})

export class TeamCallsHistoryIframePage implements OnInit {

  data = null;
  delegateId = 0;
  teamList: DelegateSummaryModel[] = [];
  customListData: Array<any> = [];

  isFirstMember = true;
  isLastMember = true;
  isSaveList = false;
  nextDelegateId = 0;
  prevDelegateId = 0;

  retries = 0;

  constructor(
    public sanitizer: DomSanitizer,
    public userService: UserService,
    private teamService: TeamService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
  ) {
  }

  ngOnInit() {
    this.delegateId = parseInt(this.activatedRoute.snapshot.paramMap.get('delegateId'), 10);
    if (this.delegateId < 1) {
      this.router.navigate(['/team']);
    }

    this.retries = 0;
    this.initUserMagicLink(this.delegateId, 'https://app.hyperbound.ai/calls');

    this.teamService.getMyTeamListModel().then(data => {
      this.teamList = data;
      this.updateButtonStatus();
    });
  }

  initUserMagicLink(delegateId, url) {
    ++this.retries;
    console.log(`initMagicLink [attempt #${this.retries}]`, url);
    this.teamService.getUserHBMagicLink(delegateId, url).then((res) => {
      if (res && res.url !== url) {
        console.log('initMagicLink Success:', res);
        this.data = res;
      } else {
        console.error(`initUserMagicLink Failed [Attempt #${this.retries}]`, res);
        setTimeout(() => {
          this.initUserMagicLink(delegateId, url);
        }, 1000);
      }
    });
  }

  updateButtonStatus() {
    this.prevDelegateId = 0;
    this.nextDelegateId = 0;
    let delegateId = 0;

    this.teamList.forEach((member, index) => {
      if (member.delegate.id === this.delegateId) {
        delegateId = this.delegateId;
      } else {
        if (member.delegate.template_id > 0) {
          if (delegateId === 0) {
            this.prevDelegateId = member.delegate.id;
          } else if (this.nextDelegateId === 0) {
            this.nextDelegateId = member.delegate.id;
          }
        }
      }
    });
  }

  prevTeamMember() {
    if (this.prevDelegateId) {
      this.router.navigate(['/team/calls/' + this.prevDelegateId]);
    }
  }

  nextTeamMember() {
    if (this.nextDelegateId) {
      this.router.navigate(['/team/calls/' + this.nextDelegateId]);
    }
  }

}
